<template>
  <div class="custom-fields">
    <div class="error-msg-area">
      <alert-msg
        v-if="(this.fields.includes('Email')) && $v.user_email.$error && !$v.user_email.email"
        :errorMsg="$t('invalid_email')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('Name')) && $v.user_name.$error && !$v.user_name.required"
        :errorMsg="$t('name_error')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('Email')) && $v.user_email.$error && !$v.user_email.required"
        :errorMsg="$t('email_error')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('Phone Number') || this.fields.includes('Phone')) && $v.user_phone.$error && !$v.user_phone.required"
        :errorMsg="$t('phone_error')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('Gender')) && $v.gender.$error && !$v.gender.required"
        :errorMsg="$t('gender_error')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('Country')) && $v.user_country.$error && !$v.user_country.required"
        :errorMsg="$t('country_error')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('City')) && $v.user_city.$error && !$v.user_city.required"
        :errorMsg="$t('city_error')">
      </alert-msg>
      <alert-msg
        v-if="(this.fields.includes('Year Born') || this.fields.includes('Date of Birth') || this.fields.includes('DOB')) && $v.user_dob.$error && !$v.user_dob.required"
        :errorMsg="$t('dob_error')">
      </alert-msg>
      <alert-msg
        v-if="this.fields.includes('Phone PIN') && $v.phone_pin.$error && !$v.phone_pin.required"
        :errorMsg="$t('pin_error')">
      </alert-msg>
      <span v-for="(field, index) in userCreatedCustomFields" :key="index">
        <alert-msg
          v-if="field.error"
          :errorMsg="$t('custom_field_error', {fieldName: upcaseName(field.name)})">
        </alert-msg>
      </span>
    </div>

    <div v-for="(field, index) in this.fields" :key="index" class="custom-field-container">
      <div 
        class="input-container" 
        :class="{ 'input-error': $v.user_name.$error }" 
        v-if="field === 'Name'"
      >
        <input 
          class="custom-input" 
          placeholder=" "
          v-model.trim="user_name"
          @input="delayTouch($v.user_name)"
          type="text" 
        >
        <label class="custom-label">
          <span class="label-text">
            {{ $t('placeholder_name') }}
          </span>
          <span class="label-optional" v-if="isOptionalFields('Name')">
            ({{ $t('optional') }})
          </span>
        </label>
      </div>

      <div class="input-container" :class="{ 'input-error': $v.user_email.$error }" v-if="field ==='Email'">
        <input
          v-model.trim="user_email"
          @blur="delayTouch($v.user_email)"
          type="email"
          placeholder=" "
        >
        <label class="custom-label">
          <span class="label-text">
            {{ $t('placeholder_email') }}
          </span>
          <span class="label-optional" v-if="isOptionalFields('Email')">
            ({{ $t('optional') }})
          </span>
        </label>
      </div>

      <div 
        v-if="field === 'Gender'" 
        class="gender-div" 
        :class="{ 'input-error': $v.gender.$error }"
      >
        <p style="color: #777777; margin-left: 10px"> {{ placeholder('element_gender', 'Gender') }} </p> 
        <input value="male"
          v-model.trim="gender"
          @input="delayTouch($v.gender)"
          type="radio" id="male"
          name="radio-group"
          checked
        >
        <label for="male"
          style="padding-right: 20px;">
          {{ $t('gender_type_male') }}
        </label>
        <input value="female"
          v-model.trim="gender"
          @input="delayTouch($v.gender)"
          type="radio"
          id="female"
          name="radio-group">
        <label for="female"
          style="padding-right: 10px;">
          {{ $t('gender_type_female') }}
        </label>
      </div>

      <div 
        class="input-container" 
        v-if="field === 'Country'"
        :class="{'div-error': $v.user_country.$error }"
      >
        <div 
          class="country-select"
        >
          <label
            class="floating-label"
            :class="{ 'float': user_country || isCountrySelectOpen }"
            for="customSelect"
          >
            {{ $t('placeholder_country') }}
          </label>
          <v-select
            v-model="user_country"
            label="country"
            :options="countries"
            placeholder=" "
            append-to-body
            @open="isCountrySelectOpen = true"
            @close="isCountrySelectOpen = false"
          />
        </div>
      </div>

      <div class="input-container" :class="{ 'input-error': $v.user_city.$error }" v-if="field === 'City'">
        <input
          type="text"
          v-model.trim="user_city"
          @input="delayTouch($v.user_city)"
          placeholder=" "
        >
        <label class="custom-label">
          <span class="label-text">
            {{ $t('placeholder_city') }}
          </span>
          <span class="label-optional" v-if="isOptionalFields('City')">
            ({{ $t('optional') }})
          </span>
        </label>
      </div>

      <div class="phone-code"
        v-if="field === 'Phone Number' || field === 'Phone'"
        style="display: flex; flex-direction: column;"
      >
        <div style="display: flex;">
          <div
            @click.prevent="countryModal = true"
            class="phone-flag"
          >
            <span>{{ flag }}&#160;{{ code }}</span>
          </div>
          <div class="input-container" :class="{ 'input-error': $v.user_phone.$error }">
            <input 
              v-model.trim="user_phone"
              @input="delayTouch($v.user_phone)"
              @keyup="numberFormat"
              type="tel"
              placeholder=" " 
            >
            <label class="custom-label">
              <span class="label-text">
                {{ $t('placeholder_phone') }}
              </span>
              <span class="label-optional" v-if="isOptionalFields(field === 'Phone Number' ? 'Phone Number' : 'Phone')">
                ({{ $t('optional') }})
              </span>
            </label>
          </div>
        </div>
        <transition name="modal"  >
          <div v-if="countryModal" >
            <country-selector 
              @select="onSelect"
              @close="closeCountryModal"
            />
          </div>
        </transition>
      </div>

     <input
        style="margin-top: 15px;"
        v-if="field === 'Year Born' || field === 'Date of Birth' || field === 'DOB'"
        v-model.trim="user_dob"
        @input="delayTouch($v.user_dob)"
        type="hidden"
      >
      <div 
        class="input-container" 
        :class="{ 'input-error': $v.user_dob.$error }" v-if="field ==='Year Born' || field === 'Date of Birth' || field === 'DOB'"
        v-click-outside="handleClickOutside"
      >
        <label
          class="floating-label"
          :class="{ 'float': birthday || isDatePickerOpen }"
          for="datepicker"
        >
          {{ $t('placeholder_dob') }}
        </label>
        <Datepicker
          v-model.trim="birthday"
          @opened="scrollToDatePicker; isDatePickerOpen = true"
          placeholder= " "
          class="Date-picker"
          initialView="year"
          :language="datePickerLanguage"
          :fullMonthName="false"
          :open-date="new Date('1990/01/01')"
          format="MM/dd/yyyy"
        />
      </div>
      <input type="hidden" v-model="user_dob">
      <div class="input-container" :class="{ 'input-error': $v.phone_pin.$error }" v-if="field ==='Phone PIN'">
        <input 
          type="tel"
          v-bind:class="{ 'input-error': $v.phone_pin.$error }"
          v-model="phone_pin"
          v-mask="'####'"
          @input="delayTouch($v.phone_pin)"
          placeholder=" "
        >
        <label class="custom-label">
          <span class="label-text">
            {{ $t('enter_pin') }}
          </span>
          <span class="label-optional" v-if="isOptionalFields('Phone PIN')">
            ({{ $t('optional') }})
          </span>
        </label>
      </div>

      <template v-if="userCreatedCustomFields.length > 0" >
        <div v-for="(customField, index) in userCreatedCustomFields" :key="index" style="width: 320px;">
          <template v-if="customField.type === 'select'">
            <div class="input-container" :class="{ 'input-error': customField.error } " v-if="field === customField.name">
              <v-select
                :options="JSON.parse(customField.values_custom_fields)"
                style="min-width: 320px;margin-top: 10px;"
                v-model="customField.value"
                @change="setCustomFieldsValidations(customField)"
                :placeholder="customField.placeholder + (customField.required === 0 ? ' (optional)' : '')"
              />
            </div>
          </template>
          <template v-else>
            <div class="input-container" :class="{ 'input-error': customField.error }" v-if="field === customField.name">
              <input
                v-model="customField.value"
                :type="customField.type"
                @input="setCustomFieldsValidations(customField)"
                placeholder=" "
              >
              <label class="custom-label">
                <span class="label-text">
                  {{ customField.placeholder }}
                </span>
                <span class="label-optional" v-if="customField.required === 0">
                  ({{ $t('optional') }})
                </span>
              </label>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength, email, numeric } from 'vuelidate/lib/validators'
import AlertMsg from './../../components/errors/alert.vue';
import FormField from '../payments/cleave.vue'
import { mask } from 'vue-the-mask'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import Datepicker from 'vuejs-datepicker';
import * as languages from 'vuejs-datepicker/dist/locale'
import snakeCase from "lodash/snakeCase";
import startCase from "lodash/startCase";
import { parsePhoneNumber } from 'awesome-phonenumber'
import CountrySelector from '../phone/country-selector.vue'
import { find } from 'lodash'
import allCountries from '../phone/country-codes.json'
import vClickOutside from 'v-click-outside'

const touchMap = new WeakMap();

export default {
  components: {
    FormField,
    AlertMsg,
    vSelect,
    Datepicker,
    CountrySelector,
  },
  data(){
    return {
      dynamicCustomFields: {},
      dateLanguages: languages,
      user_email: (this.value && this.value.user_email) || '',
      user_name: (this.value && this.value.user_name) || '',
      user_phone: (this.value && this.value.user_phone) || '',
      user_country: (this.value && this.value.user_country) || '',
      user_city: (this.value && this.value.user_city) || '',
      countries: ["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegowina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, the Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao, People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia (Slovak Republic)", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zambia", "Zimbabwe"
      ],
      user_dob: (this.value && this.value.user_dob) || '',
      gender: (this.value && this.value.gender) || '',
      code: '+1',
      country: '',
      flag: '',
      phone_pin: '',
      phone:{},
      validPhone: true,
      birthday: (this.value && this.value.user_dob) || '',
      customFieldNames: [],
      customFields: [
        {
          name: 'Name',
          field: 'user_name',
          validation: {required}
        },
        {
          name: 'Email',
          field: 'user_email',
          validation: this.consentAccepted === undefined ? {required, email} : this.consentAccepted ? {email} : {required, email}
        },
        {
          name: 'Phone Number',
          field: 'user_phone',
          validation: {required}
        },
        {
          name: 'Phone',
          field: 'user_phone',
          validation: {required}
        },
        {
          name: 'Country',
          field: 'user_country',
          validation: {required}
        },
        {
          name: 'City',
          field: 'user_city',
          validation: {required}
        },
        {
          name: 'Gender',
          field: 'gender',
          validation: {required}
        },
        {
          name: 'Year Born',
          field: 'user_dob',
          validation: {required}
        },
        {
          name: 'Date of Birth',
          field: 'user_dob',
          validation: {required}
        },
        {
          name: 'DOB',
          field: 'user_dob',
          validation: {required}
        },
        {
          name: 'Phone PIN',
          field: 'phone_pin',
          validation: {required}
        }
      ],
      userCreatedCustomFields: [],
      countryModal: false,
      showMessage: {
      },
      clickTimer: {},
      isCountrySelectOpen: false,
      isDatePickerOpen: false,
    }
  },
  directives: {
    mask,
    clickOutside: vClickOutside.directive,
  },
  mounted(){
    if(this.baseData.customFields.length > 0) {
      this.userCreatedCustomFields = this.baseData.customFields;
    }
    this.checkRegion()
    this.checkUserCustomFields()
  },
  computed: {
    datePickerLanguage() {
      if(this.dateLanguages[this.lang]){
        return this.dateLanguages[this.lang]
      }
      return this.dateLanguages['en']
    },
    lang(){
      return this.$i18n.locale
    },
    valid(){
      return !this.$v.$invalid
    },
    customFieldsPayload() {
      return this.baseData.customFields;
    },
    payload(){
      let payload = {
        customfields: {}
      }
      let value = null

      this.fields.forEach((a, i)=>{
        value = this.customFields.find(item=>item.name===a)
        if(!!value && this.existingCustomFields.includes(value.field)) {
          payload[value.field] = this[value.field]
          if(value.field === 'user_phone'){
            payload.country = this.code.replace(/\D/g,'')
          }
        } else {
          this.userCreatedCustomFields.forEach(field => {
            if(snakeCase(a) === field.field) {
              payload["customfields"][field.id] = field.value || ""
            }
          })
        }
      })
      return payload
    },
    existingCustomFields() {
      return ['user_name','user_email','user_phone','user_phone','user_country','user_city','gender','user_dob','user_dob','user_dob','phone_pin']
    },
    isUserCreatedCustomFieldsHasError() {
      const checkIfAnyError = this.userCreatedCustomFields.map(field => !!field.error ? true : false)
      return checkIfAnyError.includes(true)
    }
  },
  validations() {
    let rules = {}
    let value = null

    this.fields.forEach((item, index)=>{
      value = this.customFields.find(a=>a.name===item)
      if(!value) return
      rules[value.field] = value.validation
      if(value.field === 'user_phone'){
        rules.code = {required}
      }
    })

    return rules;
  },
  props: {
    fields: {
      type: Array
    },
    value: {
      require: true,
    },
    baseData: {
      type: Object
    },
    consentAccepted: {
      type: Boolean,
      default: undefined
    },
  },
  watch: {
    payload(){
      this.$emit('input', this.payload)
    },
    birthday() {
      if(this.birthday) {
        this.user_dob = moment(this.birthday).format('MM/DD/YYYY')
      }
      else{
        this.user_dob = ''
      }
    },
    customFieldsPayload: {
      deep: true,
      handler() {
        if(this.baseData.customFields.length > 0) {
          this.userCreatedCustomFields = this.baseData.customFields;
        } else {
          this.userCreatedCustomFields = []
        }
      }
    }
  },
  methods: {
    onSelect(country) {
      this.code = country.dialCode
      this.country = country.code
      this.flag = country.flag
      this.user_phone = ''
      setTimeout(() => {
        this.countryModal = false
      }, 700);
      this.$v.$reset()
    },
    setCustomFieldsValidations(field) {
      if(!!field.required) {
        !field.value ? field.error = true : field.error = false
      }
    },
    upcaseName(name) {
      return startCase(name)
    },
    checkUserCustomFields() {
      if(this.userCreatedCustomFields.length > 0) {
        this.userCreatedCustomFields = this.userCreatedCustomFields.map(customField => {
          customField.field = snakeCase(customField.name)
          customField.error = false
          return customField
        })
      }
    },
    checkRegion(){
       if(this.baseData.region && this.baseData.region.phoneCode){
         this.code = this.baseData.region.phoneCode
        }
        this.updateFlag(this.code);
    },
    async loadCountries() {
      const countries = await import("../phone/country-codes.json");
      return countries
    },
    async updateFlag(code){
      if(allCountries){
        const country = find(allCountries, function(o) { return o.dialCode === code}) 
        if(country && country.flag){
          this.flag = country.flag
        }
      }
    },
    delayTouch($v) {
      $v.$reset()
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set(
        $v, setTimeout(
          $v.$touch, 500
        )
      )
    },
    isPhone(field){
      return ['Phone', 'Phone Number'].includes(field)
    },
    allValid() {
      this.runAllChecks();
      // Not so smart solution to wait for 1s to finish validation.
      // Need to wait for vuelidate to support async validation on delayTouch
      setTimeout(()=>{
        this.valid && !this.isUserCreatedCustomFieldsHasError ? this.$emit('valid') : this.$emit('invalid')
      }, 1000)

    },
    runAllChecks() {
      this.userCreatedCustomFields = this.userCreatedCustomFields.map(field => {
        field.error = false;
        return field
      })
      setTimeout(()=>{
        this.userCreatedCustomFields = this.userCreatedCustomFields.map(field => {
          if(!!field.required) {
            !!field.value ? field.error = false : field.error = true;
          }
          return field
        })
        this.fields.forEach((field, i)=>{
          this.customFields.find(item=>item.name===field) && this.delayTouch(this.$v[this.customFields.find(item=>item.name===field).field])
          if(this.isPhone(field)){
            this.delayTouch(this.$v.code)
          }
        })
        this.fields.includes('Gender') ? this.delayTouch(this.$v.gender) : '';
      }, 1000)
    },
    numberFormat() {
      if(this.code==='+1'){
        let input = this.user_phone;
        input = input.replace(/\D/g, '');
        input = input.substring(0, 12);
        let size = input.length;
        if (size === 0) {
          input = input;
        }
        else if (size < 4) {
          input = '(' + input;
        }
        else if (size < 7) {
          input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
        }
        else if (size > 10) {
          input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 7) + ' - ' + input.substring(7, 12);
        }
        else {
          input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + ' - ' + input.substring(6, 12);
        }
        this.user_phone = input;
        this.isCanadianPhone();
        return
      }
      this.phone = parsePhoneNumber( this.user_phone, { regionCode: this.country } );
      this.user_phone = this.phone.number.national ? this.phone.number.national : this.phone.number.input

    },
    isCanadianPhone() {
      let areaCode = this.user_phone.replace(/\D/g, '').substring(0, 3);
      const canadianAreaCodes = [
        '403', '587', '780', '825', // Alberta
        '236', '250', '604', '672', '778', // British Columbia
        '204', '431', // Manitoba
        '506', // New Brunswick
        '709', // Newfoundland and Labrador
        '867', // Northwest Territories, Yukon, Nunavut
        '782', '902', // Nova Scotia and Prince Edward Island
        '226', '249', '289', '343', '365', '416', '437', '519', '548',
        '613', '647', '705', '753', '807', '905', // Ontario
        '367', '418', '438', '450', '514', '579', '581', '819', '873', // Quebec
        '306', '474', '639' // Saskatchewan
      ];
      const countryCode = canadianAreaCodes.includes(areaCode) ? 'CA' : 'US';
      const country = find(allCountries, function(o) { return o.code === countryCode}) 
      if(country && country.flag){
        this.flag = country.flag
      }
    },
    scrollToDatePicker() {
      const datePicker = document.querySelector('.Date-picker')
      datePicker && datePicker.scrollIntoView()
    },
    validateNumber() {
      if(!this.phone.valid){
        this.validPhone = false
      }
    },
    closeCountryModal(){
      this.countryModal = false
    },
    placeholder(option, fieldname){
      const field = this.customFields.find(field => field.name === fieldname)
      const placeholder = this.$t(option) + (['DOB', 'Date of Birth', 'Year Born'].includes(field.name) ? '(mm/dd/yyyy)' : '') + (field.validation && field.validation.required ? '' : ' (' + this.$t('optional') + ')')
      return placeholder
    },
    isOptionalFields(fieldname){
      const field = this.customFields.find(field => field.name === fieldname)
      return !(field.validation && field.validation.required)
    },
    handleClickOutside() {
      this.isDatePickerOpen = false;
    },
  }
}
</script>

<style scoped>
  .country-select {
    width: 100%;
    border: none;
    outline: none;
    justify-content: center;
    align-items: center;
    margin: auto;
    height: 40px;
  }

  .div-error {
    border-color: red;
    background: #f7eaea;
  }  
  .div-error  {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
  .div-error >>> .vs__dropdown-toggle {
    background: border-box;
  }
  .country-select >>> .vs__dropdown-toggle  {
    border: none !important;
    height: 38px;
    border-radius: 32px;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
  }
  .country-select >>>  .vs__search{
    width: 20px !important;
    border: none !important;
    box-shadow: none !important;
    padding-top: 30px!important;
    padding-left: 6px!important;
  }

  .country-select >>> .vs__selected-options{
    align-items: center !important;
  }
  .country-select >>> .vs__clear{
    display: none;
  }
  .country-select >>> .vs__actions{
    margin-right: 15px;
  }
  .country-select >>> .vs__selected{
    position: absolute;
    top: 23px;
  }
  .vs__dropdown-menu {
    top: 232px!important;
    left: 17px!important;
    width: 316.469px!important;
    overflow-x: clip!important;
  }
  .input-container {
    position: relative;
  }
  .gender-div {
    max-height: 52px;
    margin: 10px 0 0 0;
    padding: 0;
    border: 1px solid #ccc;
    background: #FFFFFF;
    border-radius: 32px;
    box-shadow: 2px 0 20px 0 rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .floating-label {
    position: absolute;
    top: 50%;
    left: 20px;
    color: gray;
    transition: 0.2s ease all;
    pointer-events: none;
    transform: translateY(-50%);
    z-index: 99;
  }
  .floating-label.float {
    top: 10px;
    z-index: 999;
    left: 20px;
    font-size: 11px;
    color: #7b7b7b;
  }
  .custom-select .vs__dropdown-toggle {
    padding-top: 1.2em;
    padding-bottom: 0.2em;
  }
</style>


<style lang="scss">
.select-vue{
  width: 100%;
  .dropdown{
    width: 100%;
  }
}
.Date-picker{
  color: #000000;
  padding: 0;
  margin: 0;
  height: 100%;
  border-radius: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-width: 277px;
  input{
    max-width: 100%;
    min-width: 277px;
    position: relative
  }
  .vdp-datepicker__calendar{
    position: absolute;
    top: 50px;
    border-radius: 5px;
    min-width: 100%;
    margin-left: 40px;
    .cell{
      font-size: 14px;
      &:hover{
        border: 1px solid #55acee;
        border-radius: 5px;
      }
      &.selected{
        background: #55acee;
        border-radius: 5px;
        color: white;
        &:hover{
          background: #55acee;
        }
      }
    }
  }
}
.phone-flag {
  display: flex;
  border-radius: 32px;
  justify-content: center;
  align-items: center;
  min-width: 60px;
  max-height: 50px!important;
  padding: 0 10px;
  margin: 10px 3px 0 0;
  box-shadow: 2px 0 20px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ccc;
  cursor: pointer;
  background: #ffffff;
  color: #000000;
}
.phone-input{
  max-width: 193px !important;
  max-height: 18px!important;
}
.custom-field-container {
  width: 100%;
}
</style>
